import './NotificationsPanel.scss';

export { default } from './NotificationsPanel';
